<template>
  <CommunityCard class="p-4">
    <h3 class="text-inherit mb-4">Post Requests</h3>

    <ul v-if="postRequests.length" class="list-style-none">
      <li class="my-2" v-for="req in postRequests" :key="req.id">
        <div class="request-container">
          <div class="titlerow">
            <div class="title-text">
              <h5>{{ req.title }}</h5>
              <div class="title-creator">
                {{ req.creator.first_name + " " + req.creator.last_name }} -
                {{ getPrettyDate(req.created_at) }}
              </div>
            </div>
            <div>
              <button
                :ref="'approvepost-' + req.id"
                @click="approvePostRequest(req.id)"
                class="btn btn-outline mx-1 btn-primary"
              >
                Approve
              </button>
              <button
                :ref="'declinepost-' + req.id"
                @click="declinePostRequest(req.id)"
                class="btn btn-outline mx-1 btn-danger"
              >
                Decline
              </button>
            </div>
          </div>
          <div class="bodyrow">
            {{ req.text }}
          </div>
          <template v-if="req.scenarios && req.scenarios.length">
            <hr />
            <b>Attached Scenarios</b>
            <div class="attachmentsrow">
              <div
                class="scenario-attachment"
                v-for="scen in req.scenarios"
                :key="scen.uuid_id"
              >
                <div class="scenario-name">
                  {{ scen.name }}
                </div>
                <div class="scenario-desc">
                  {{ scen.description }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </li>
    </ul>
    <div v-else>
      No post requests for group
    </div>
  </CommunityCard>
</template>

<script>
import forumGroupService from "../services/forumgroup.service";
import CommunityCard from "../components/CommunityCard";

export default {
  name: "ForumPostRequests",
  props: ["postRequests"],
  components: {
    CommunityCard,
  },
  data: function() {
    return {
      isSubmitting: false,
    };
  },
  methods: {
    approvePostRequest(requestId) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const btn = this.$refs["approvepost-" + requestId][0];
      btn.innerHTML = "...";

      forumGroupService
        .approvePostRequest(requestId)
        .then(() => {
          this.$emit("success", "Post approved.");
        })
        .finally(() => {
          this.$emit("reload");
          this.isSubmitting = false;
          btn.innerHTML = "Approve";
        });
    },
    declinePostRequest(requestId) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const btn = this.$refs["declinepost-" + requestId][0];
      btn.innerHTML = "...";

      forumGroupService
        .declinePostRequest(requestId)
        .then(() => {
          this.$emit("success", "Post declined.");
        })
        .finally(() => {
          this.$emit("reload");
          this.isSubmitting = false;
          btn.innerHTML = "Decline";
        });
    },
    getPrettyDate(dateString) {
      return new Date(dateString).toLocaleString();
    },
  },
};
</script>

<style scoped>
.request-container {
  border: 1px solid #ddd;
  padding: 6px;
  border-radius: 4px;
  margin: 16px auto;
}
.titlerow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-creator {
  font-style: italic;
  font-size: 0.8em;
}
.bodyrow {
  margin: 10px auto 0;
}
.attachmentsrow {
  display: flex;
}
.scenario-attachment {
  border: 1px solid #ddd;
  padding: 10px;
  margin: 5px;
}
</style>
